import { render, staticRenderFns } from "./LngLink.vue?vue&type=template&id=b185960a&"
import script from "./LngLink.vue?vue&type=script&lang=js&"
export * from "./LngLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports